export default __webpack_public_path__ + "static/media/BodieMoment.0f20bbf3.jpg";